import ChangeView from "components/map/ChangeView";

interface PropsData {
  area: { lat: number; lng: number }[];
}

function MapArea({ area }) {

  return (
    <div>
      {area[0]?.locLate && area[0]?.locLong ? (
        <ChangeView
          center={[area[0]?.locLate, area[0]?.locLong]}
          zoom={12}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default MapArea;
